import { Brick, registerBrick, ErrorFlow, Query } from "olympe";
import { ScenarioQueryBuilder } from "./scenario_query_builder_v3/QueryBuilder";

/**
 * @extends {Brick}
 */
export class ScenarioQueryGeneratorV3 extends Brick {
  update($, [body, modelTag], [forwardEvent, setQueries, setErrorFlow]) {
    try {
      if (!body) throw new Error("body parameter is required");

      const entityMapper = (() => {
        if (!this._mapper) {
          const paramConfigs = Query.instancesOf(
            modelTag,
            false,
            "server",
          ).executeFromCache();

          this._mapper = paramConfigs.reduce((acc, curr) => {
            const [column, field, tableName] = [
              curr.get("0185c081050d996c424c"),
              curr.get("0185c081098c285960d8"),
              `${curr.get("01862c935347456d04b2")}.${curr.get("0185c080fff9d4533458")}`,
            ];

            return column && field && tableName
              ? {
                  ...acc,
                  [tableName]: {
                    fields: [...(acc[tableName]?.fields || []), field],
                    byField: {
                      ...(acc[tableName]?.byField || {}),
                      [field]: column,
                    },
                  },
                }
              : acc;
          }, {});
        }
        return this._mapper;
      })();

      const {
        scenarioWithImpacts = {},
        bmis = [],
        sal = [],
      } = JSON.parse(body);
      const { impacts = [] } = scenarioWithImpacts;

      const queries = new ScenarioQueryBuilder(
        scenarioWithImpacts,
        impacts,
        bmis,
        sal,
        entityMapper,
      ).build();
      setQueries(queries);
    } catch (err) {
      console.error("ScenarioQueryGeneratorV3 error:", err);
      setErrorFlow(ErrorFlow.create(`Error: ${err.message}`));
    }
    forwardEvent();
  }
}

// TODO: replace with a new unique Olympe brick tag
registerBrick("019cfb7ad989490c0aa8", ScenarioQueryGeneratorV3);
